export default __webpack_public_path__ + "static/LPHowToStartImage1-35a46b061fc92762e5225c3c9ce9bb29.jpg";